// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CodeElement_wrap__3gVsn"};